import * as React from 'react';
const SvgCyberSecurity = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width={640} height={640} viewBox='297 170 57 57' {...props}>
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={1.2}
      d='M312.81 184.894c.114 8.197 4.133 15.824 12.058 22.88 7.926-7.056 12.09-14.683 12.495-22.88-5.688-.838-9.755-3.356-12.2-7.552-2.446 4.196-6.564 6.714-12.353 7.552Z'
    />
    <rect
      width={9.999}
      height={8.378}
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={1.2}
      rx={1.774}
      ry={1.774}
      transform='translate(320.042 190.884)'
    />
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={1.2}
      d='M328.064 191.032v-.04l-.026-.398-.041-.388-.056-.377-.072-.365-.085-.352-.099-.338-.112-.322-.124-.305-.136-.288-.147-.268-.157-.249-.167-.227-.176-.205-.184-.182-.192-.156-.2-.131-.206-.104-.212-.075-.217-.046-.222-.016-.222.016-.217.046-.212.075-.206.104-.199.131-.192.156-.185.182-.175.205-.167.227-.157.249-.147.268-.136.288-.124.305-.112.322-.099.338-.086.352-.071.365-.057.377-.041.388-.025.398-.001.04h5.662M309.848 185.882l-11.615 9.86 11.668 8.883M340.552 185.882l11.615 9.86-11.668 8.883'
    />
  </svg>
);
export default SvgCyberSecurity;
